<template>
  <div class="table-responsive">
    <!-- === FILTROS DE FECHA Y TIPO DE ALERTA === -->
    <vs-card class="cardx">
      <div class="default-input d-flex align-items-center table-responsive filters-row">
        
        <label class="filter-label">Desde:</label>
        <input type="datetime-local" class="input_of_find" v-model="filters.startDateTime"/>
        
        <label class="filter-label ml-1">Hasta:</label>
        <input type="datetime-local" class="input_of_find" v-model="filters.endDateTime"/>

        <label class="filter-label ml-1">Tipo de Alerta:</label>
        <input type="text" class="input_of_find" v-model="filters.alertType" placeholder="Ej: Altura Pretil"/>

        <vs-button class="ps_rem_button ml-1" @click="fetchAlerts" color="darkgreen" type="border" icon="search"></vs-button>
      </div>
    </vs-card>
    <!-- === FIN: FILTROS === -->

    <!-- Tabla de Alertas -->
    <vs-table 
      :data="alerts" 
      v-if="alerts.length > 0"
      pagination 
      :max-items="5" 
      search
      max-width="100%" 
      noDataText="No existen registros para los filtros seleccionados."
    >
      <template slot="thead">
        <vs-th sort-key="datetime">Fecha y Hora</vs-th>
        <vs-th sort-key="type">Tipo de Alerta</vs-th>
        <vs-th>Geolocalización</vs-th>
        <vs-th>Evidencia</vs-th>
      </template>

      <template slot-scope="{data}">
        <vs-tr :key="indextr" v-for="(tr, indextr) in data" >
          <vs-td :data="tr.datetime">
            {{ formatDateTime(tr.datetime) }}
          </vs-td>
          <vs-td :data="tr.type">
            {{ tr.type }}
          </vs-td>
          <vs-td :data="tr.lat">
            <!-- Botón para el Mapa -->
            <vs-button @click="openMapModal(tr)" color="success" type="filled" size="small">Ver Mapa</vs-button>
          </vs-td>
          <vs-td :data="tr.alert_json.thumbnail">
            <!-- Botón para la Imagen: Llama a openThumbnailModal con la Base64 de la fila actual (tr) -->
            <vs-button v-if="tr.alert_json && tr.alert_json.thumbnail" 
                       @click="openThumbnailModal(tr.alert_json.thumbnail)" 
                       color="primary" type="filled" size="small">
              Ver Imagen
            </vs-button>
            <span v-else>Sin Imagen</span>
          </vs-td>
        </vs-tr>
      </template>
    </vs-table>

    <div v-else class="no_register_proximity">
        No existen registros para los filtros seleccionados.
    </div>

    <!-- Modal para el MAPA (vs-popup) -->
    <vs-popup :title="modalTitle" :active.sync="isModalOpen" :class="{'map-popup': modalContent === 'map', 'vs-popup-ahumada':  'min-height: 725px !important'}">
      <div v-if="modalContent === 'map'" class="map-container">
        <div v-if="!activeModalData || !activeModalData.lat || activeModalData.lat == 0">
            <p>Geolocalización no disponible para esta alerta.</p>
        </div>
        <!-- El componente leaflet se monta/actualiza solo si el modal está abierto y hay datos -->
        <div v-else-if="isModalOpen" class="map-wrapper"> 
            <leaflet :lat="activeModalData.lat" :lon="activeModalData.lon" />
        </div>
      </div>
    </vs-popup>

    <!-- Modal para la IMAGEN (Thumbnails dentro de vs-popup) -->
    <!-- Se abre si isThumbnailOpen es true y usa la data cargada en activeThumbnailSrc -->
    <vs-popup title="Evidencia de Alerta" :active.sync="isThumbnailOpen" class="dynamic-image-popup">
        <div class="image-popup-wrapper flex justify-center items-center">
            <!-- activeThumbnailSrc contiene el Base64 procesado o el placeholder -->
            <Thumbnails :img="activeThumbnailSrc" />
        </div>
    </vs-popup>

  </div>
</template>

<script>
import axios from "axios";
// Las rutas deben ser correctas en su proyecto
import leaflet from "../utils/Map_one_point"; 
import Thumbnails from "../utils/Thumbnails"; 

export default {
  name: "AlertsProximity",
  props:{
    box_id: Number
  },
  components: {
    leaflet,
    Thumbnails // Registramos el componente de imagen
  },
  data:()=>({
    // La lista de alertas se cargará desde la API
    alerts: [],
    filters: {
      startDateTime: '',
      endDateTime: '',
      alertType: ''
    },
    isModalOpen: false, // Controla la visibilidad del vs-popup (MAPA)
    isThumbnailOpen: false, // Controla la visibilidad del modal de la IMAGEN (Thumbnails)
    modalContent: null,
    activeModalData: null, // Datos para el mapa (lat, lon)
    activeThumbnailSrc: null // URL Base64 para la imagen (Thumbnails)
  }),
  computed: {
    modalTitle() {
      if (this.modalContent === 'map') return 'Geolocalización de la Alerta';
      return 'Detalle';
    }
  },
  methods:{
    /**
     * MÉTODOS DE MINIATURAS (VERIFICACIÓN Y PROCESAMIENTO DE BASE64)
     * Procesa la cadena Base64, añade el prefijo MIME si falta o devuelve el placeholder.
     * @param {string} base64Data - La cadena Base64 de la imagen.
     * @returns {string} El URL de datos (`data:image/...`) o el path al placeholder.
     */
    getThumbnailSrc(base64Data) {
      // 1. Verificar si la data Base64 existe y es válida (longitud mínima para ser útil)
      if (base64Data && typeof base64Data === 'string' && base64Data.length > 50) {
        // 2. Verificar si ya tiene el prefijo (data:image/...)
        if (base64Data.startsWith('data:image/')) {
          return base64Data;
        } else {
          // 3. Añadir el prefijo MIME para Base64 (asumiendo formato JPEG/JPG)
          return `data:image/jpeg;base64,${base64Data}`;
        }
      } 
      // 4. Devolver la imagen por defecto (placeholder) si no hay Base64 válido
      else {
        // Usa require() según la sintaxis de su framework/bundler para assets
        return require('@/assets/image_not_available.jpg');
      }
    },

    fetchAlerts(){
      const url_api = this.$store.state.url_api;
      const params = { box_id: this.box_id };

      if (this.filters.startDateTime) {
        params.start_date = this.filters.startDateTime.replace('T', ' ');
      }

      if (this.filters.endDateTime) {
        params.end_date = this.filters.endDateTime.replace('T', ' ');
      }

      if (this.filters.alertType) {
        params.type = this.filters.alertType;
      }
      
      this.$vs.loading();
      axios.get(url_api + 'base/alerts', { params })
        .then(response => {
          this.alerts = response.data;
        })
        .catch((error) => {
          console.error("Error al obtener alertas:", error);
          this.$vs.notify({ title: 'Error', text: 'Fallo al cargar alertas.', color: 'danger' });
          this.alerts = [];
        })
        .finally(() => {
            this.$vs.loading.close();
        });
    },
    formatDateTime(isoString) {
      if (!isoString) return '';
      // Se añade 'Z' para tratar la cadena como UTC antes de convertir a la zona horaria local chilena
      const date = new Date(isoString + 'Z'); 
      return date.toLocaleString('es-CL', {
          timeZone: 'America/Santiago',
          year: 'numeric',
          month: '2-digit',
          day: '2-digit',
          hour: '2-digit',
          minute: '2-digit',
          second: '2-digit',
          hour12: false
      });
    },
    
    // Función dedicada a abrir el Modal del MAPA (vs-popup)
    openMapModal(data) {
        // 1. Resetear el estado del modal de imagen
        this.isThumbnailOpen = false;
        this.activeThumbnailSrc = null;

        // 2. Establecer datos del mapa y abrir el vs-popup
        this.modalContent = 'map';
        this.activeModalData = { lat: data.lat, lon: data.lon };
        this.isModalOpen = true;
    },

    // Función dedicada a abrir el Modal de la IMAGEN (Thumbnails Component dentro de vs-popup)
    openThumbnailModal(base64Data) {
        // 1. Resetear el estado del modal del mapa
        this.isModalOpen = false;
        this.modalContent = null;
        this.activeModalData = null;

        // 2. Establecer datos de la imagen (usando la función robusta) y abrir el modal
        this.activeThumbnailSrc = this.getThumbnailSrc(base64Data); 
        this.isThumbnailOpen = true;
    }
  },
  watch: {
    // CRÍTICO para asegurar que Leaflet (el mapa) se renderice bien dentro del vs-popup
    isModalOpen(newValue) {
      if (newValue && this.modalContent === 'map') {
          this.$nextTick(() => {
              // Pequeño retardo para asegurar que el DOM del modal esté completamente renderizado
              setTimeout(() => {
                  window.dispatchEvent(new Event('resize')); 
              }, 200); 
          });
      }
    }
  },
  mounted(){
    // Cargar datos al iniciar
    this.fetchAlerts();
  }
}
</script>

<style scoped>
/* --- ESTILOS DE TABLA Y FILTROS --- */
.filters-row {
    flex-wrap: wrap;
    gap: 10px; /* Espacio entre los elementos de filtro */
}
.filter-label {
    font-weight: bold;
    margin-left: 10px;
    margin-right: 5px;
    color: #333;
    white-space: nowrap;
}
.input_of_find {
    padding: 8px;
    border-radius: 5px;
    border: 1px solid #ccc;
    background-color: #fff;
    flex-grow: 1;
    min-width: 150px;
}
.ml-1 {
    margin-left: 1rem;
}
.no_register_proximity{
    font-weight: bold; 
    font-size: 14px;
    text-align: center;
    margin-top: 20px;
}

/* --- ESTILOS CRÍTICOS PARA EL MAPA (vs-popup) --- */

/* 1. Forzar el tamaño del contenedor del mapa dentro del vs-popup */
.vs-popup.map-popup .vs-popup--content {
    /* Usar vw/vh para que el modal escale con el zoom del navegador */
    width: 90vw !important; 
    height: 90vh !important;
    max-width: 90vw !important; 
    max-height: 90vh !important;
    min-height: 400px !important; 
}

/* 2. Asegurar que el contenedor del contenido del modal sea 100% de la altura */
.vs-popup.map-popup .vs-popup--content > div {
    height: 100%;
}

/* 3. El contenedor directo del mapa (map-container) debe ser 100% */
.map-container {
    height: 100%;
}

/* 4. El wrapper final para el componente Leaflet debe tener una altura definida */
.map-wrapper {
    /* Usar un valor fijo o relativo (como 95% o calc) para dar espacio al título/cuerpo */
    height: 95%; 
    width: 100%;
}

/* --- ESTILOS PARA IMAGEN (vs-popup) --- */
.vs-popup.dynamic-image-popup .vs-popup--content {
    /* Asegurar que la imagen tenga un tamaño razonable en el modal */
    width: auto !important;
    max-width: 90vw !important; 
    height: auto !important;
    max-height: 90vh !important;
}

.image-popup-wrapper {
    /* Darle un espacio fijo o máximo al thumbnail dentro del popup */
    max-width: 800px; 
    max-height: 70vh;
    margin: 0 auto;
}

/* --- ESTILOS PARA IMAGEN (Mantenidos por precaución) --- */
.imgAlert {
    max-width: 100%;
    max-height: 80vh;
    height: auto;
    display: block;
    margin: 0 auto;
}
.vs-popup-ahumada div{
    /* Mantenido: Estilo específico para min-height */
    min-height: 725px !important;
}
</style>